const Apexchart = {
  settings(id = "apexchart", showToolbar = true) {
    return {
      chart: {
        id: id,
        type:"line",
        toolbar: {
          show: showToolbar, 
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
          },
          export:{
            csv: {filename: 'export'}
          },
          autoSelected: 'zoom'
        },
        animations: {
          enabled: false,
          animateGradually: {
            enabled: false
          },
          dynamicAnimation: {
            enabled: false
          }
        },
      },
      markers: {
        size: 3,
        strokeWidth: 0,
      },

      theme: {
        palette: "palette3"
      },
      xaxis: {
        type: "datetime",
        labels: {
          format: "dd MMM HH:mm"
        },
        tickPlacement: 'on',
      },
      yaxis: {
        type: "numeric",
        labels: {
            formatter: function (val) {
              return val ? val.toFixed(2) : val;
          }
        }
      },
       dataLabels: {
        enabled: false
      }, 
      stroke: {
        show: true,
        curve: "smooth",
      },
      tooltip: {
        x: { format: "dd MMM HH:mm" }
      },
      legend: {
        show: true
      }
    } 
  }   
}


export default Apexchart;